module.exports = __webpack_public_path__ + "img/qrcode_download.813ca92f.png";